import "core-js/modules/es.array.push.js";
import { showToast, showImagePreview, Image as VanImage } from 'vant';
import 'vant/es/toast/style';
import 'vant/es/image-preview/style';
export default {
  data() {
    return {
      viewhight: window.innerHeight - 50
    };
  },
  components: {
    [showImagePreview.name]: showImagePreview,
    [VanImage.name]: VanImage
  },
  methods: {
    preview2() {
      showImagePreview({
        images: ['/img/people.jpg'],
        closeable: true,
        maxZoom: 10
      });
      //showImagePreview([images:[ '/img/fee.jpg'],closeable:true]);
    },
    onClickCart() {
      this.$router.push('cart');
    },
    sorry() {
      showToast('暂无后续逻辑~');
    }
  }
};